import { Outlet } from "react-router";
import { NavigationBar } from "shared/components/navigation";
import { PageLoading } from "shared/components/utils/PageLoading";
import { useOpenFeatureFlag } from "shared/hooks";
import MaintenancePage from "modules/Internal/pages/Maintenance.page";

const ApplicationLayout = ({ withShopNavigation = false }: { withShopNavigation?: boolean }) => {
  const { loading, value: maintenanceEnabled } = useOpenFeatureFlag("maintenance_screen_enabled");

  // User/shop providers sit above this layout and remain mounted in every branch.
  if (loading) return <PageLoading />;
  if (maintenanceEnabled) return <MaintenancePage />;

  return (
    <>
      <NavigationBar withShopNavigation={withShopNavigation} />
      <Outlet />
    </>
  );
};

export { ApplicationLayout };
